export const gfpaDetailsGroupsColumnsFields = ['sectornm']

export const gfpaDetailsGroupHeaderNameMap: { [key: string]: string } = {
  country_issue_code: 'Country Code',
  currency_code: 'Currency Code',
  sector: 'Sector',
  security_id: 'Security',
}

export const columnRowGroupEventSourceTypes = ['columnMenu', 'toolPanelUi']

export const gfpaDetailsColumnsFieldsToDisplay = [
  'begin_date',
  'end_date',
  'security_id',
  'security_ret_contrib',
  'description',
  'holdings',
  'mktval',
  'notional_mktval',
  'notional_weight',
  'currency_code',
  'country_issue_code',
  'security_ret',
  'model_ret',
  'fi_yield_ret_contrib',
  'fi_d1_ret_contrib',
  'fi_d2_ret_contrib',
  'fi_d3_ret_contrib',
  'fi_term_structure_ret_contrib',
  'fi_sector_ret_contrib',
  'fi_quality_ret_contrib',
  'fi_other_ret_contrib',
  'eq_industry_ret_contrib',
  'eq_country_ret_contrib',
  'eq_region_ret_contrib',
  'eq_long_mktcap_ret_contrib',
  'eq_earnings_to_price_ret_contrib',
  'eq_book_to_price_ret_contrib',
  'eq_volatility_ret_contrib',
  'eq_momentum_ret_contrib',
  'eq_fundamental_ret_contrib',
  'commodity_ret_contrib',
  'alternatives_ret_contrib',
  'model_ret_contrib',
  'currency_ret_contrib',
  'hedge_cost_contrib',
  'interaction_contrib',
  'trading_effect_contrib',
  'selection_contrib',
  'sector',
]

export const gfpaSecurityDetailsTopAndBottom5FieldsToVisible = [
  'security_id',
  'security_ret_contrib',
  'description',
  'notional_mktval',
  'notional_weight',
]

export const gfpaFieldsToApplyAggregationSum = [
  'notional_mktval',
  'notional_weight',
  'security_ret_contrib',
]
export const gfpaColumnFieldForTableChartLinkingValue = ['notional_weight']

export const gfpaSecurityDetailsDefaultColumnsFieldsToVisible = [
  'holdings',
  'security_id',
  'description',
  'mktval',
  'notional_weight',
  'moody',
  'sector',
  'security_ret_contrib',
  'model_ret_contrib',
  'selection_contrib',
  'fi_yield_ret_contrib',
  'fi_d1_ret_contrib',
  'fi_term_structure_ret_contrib',
  'fi_sector_ret_contrib',
  'fi_quality_ret_contrib',
  'fi_other_ret_contrib',
  'fi_other_ret_contrib',
]

export const gfpaTopAndBottomFiveSecuritiesFilterKey = 'security_ret_contrib'

export const GFPASecurityDetailsFieldsPrecision: { [key: string]: number } = {
  holdings: 0,
  notional_mktval: 2,
  portsec_holdings: 0,
  portsec_notional_mktval: 2,
}

export const gfpaSecurityDetailsFieldsToHide = [
  'report_id',
  'begin_date',
  'end_date',
]
